import { useEffect } from "react";
import { Radio, MapPinOff } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { startTracking, stopTracking, useTracking } from "../lib/tracker";

const shouldTrack = (user) => !!user && user.role === "kierowca";

export const LocationTracker = () => {
  const { user } = useAuth();
  const on = shouldTrack(user);
  useEffect(() => {
    if (on) startTracking(); else stopTracking();
    return () => stopTracking();
  }, [on]);
  return null;
};

export const TrackingBadge = ({ className = "" }) => {
  const { user } = useAuth();
  const t = useTracking();
  if (!shouldTrack(user) || t.status === "off") return null;
  const active = t.status === "active";
  const denied = t.status === "denied" || t.status === "unsupported";
  const label = active ? "Pozycja na żywo" : denied ? "Włącz lokalizację" : "Szukam GPS…";
  const tone = active ? "bg-emerald-50 text-emerald-700 ring-emerald-200" : denied ? "bg-amber-50 text-amber-700 ring-amber-200" : "bg-zinc-100 text-zinc-500 ring-zinc-200";
  const retry = () => { stopTracking(); startTracking(); };
  return (
    <button type="button" onClick={retry} data-testid="tracking-badge" data-status={t.status}
      title={denied ? "Zezwól na lokalizację w ustawieniach przeglądarki i dotknij, aby spróbować ponownie" : t.error || label}
      className={`inline-flex items-center gap-1.5 h-8 px-2.5 rounded-full ring-1 text-[11px] font-bold uppercase tracking-wider ${tone} ${className}`}>
      {denied ? <MapPinOff className="w-3.5 h-3.5" /> : <span className={`w-2 h-2 rounded-full ${active ? "bg-emerald-500 animate-pulse" : "bg-zinc-400"}`} />}
      <span className={denied ? "" : "hidden sm:inline"}>{label}</span>
      {active && <Radio className="w-3.5 h-3.5 sm:hidden" />}
    </button>
  );
};
